import React from 'react';
import { ButtonProps } from '../../menus/buttons/types';
import AddImage from '@wix/da-ds/pkg/Icons/24x24/AddImage';
import EditorImage from '@wix/da-ds/pkg/Icons/24x24/EditorImage';
import AddGallery from '@wix/da-ds/pkg/Icons/24x24/AddGallery';
import AddVideo from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import { useTranslation } from 'react-i18next';
import EditorIconButtonWithContextMenu from '../../menus/_partials/EditorIconButtonWithContextMenu';
import { useHandleDeviationClick } from './Deviation';
import { useVideoButton } from './Video';
import DaVideoPopup from '../../../extensions/extension-video/components/DaVideoPopup';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useHandleGalleryClick } from './Gallery';

const AddMedia: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');

  const handleDeviationClick = useHandleDeviationClick(editor);
  const handleGalleryClick = useHandleGalleryClick(editor);
  const {
    isModalShown,
    openModal: openVideoModal,
    closeModal: closeVideoModal,
    handleSubmit,
  } = useVideoButton(editor);

  const items = [] as any;

  if (isExtensionInstalled(editor, 'deviation')) {
    items.push({
      featureId: 'node:image',
      label: t('button.addMedia.addImage'),
      icon: <EditorImage />,
      onClick: handleDeviationClick,
    });
  }

  if (isExtensionInstalled(editor, 'gallery')) {
    items.push({
      featureId: 'node:gallery',
      label: t('button.addMedia.addGallery'),
      icon: <AddGallery />,
      onClick: handleGalleryClick,
    });
  }

  if (isExtensionInstalled(editor, 'daVideo')) {
    items.push({
      featureId: 'node:video',
      label: t('button.addMedia.addVideo'),
      icon: <AddVideo />,
      onClick: openVideoModal,
    });
  }

  if (!items.length) {
    return null;
  }

  return (
    <>
      <EditorIconButtonWithContextMenu
        featureId="node:media"
        aria-label={t('button.addMedia')}
        icon={AddImage}
        items={items}
      />
      {isModalShown && (
        <DaVideoPopup onSubmit={handleSubmit} onCancel={closeVideoModal} />
      )}
    </>
  );
};
AddMedia.displayName = 'AddMedia';

export default AddMedia;
